// extracted by mini-css-extract-plugin
export default {"root":"lp3dh7","ellipsis":"fvLiSM"};